import * as React from "react";
import {cx} from "emotion";

import "./voucher-modal.scss";

import {cs}                from "@Common/react/chain-services";
import {consumeContext}    from "@Common/react/context";
import {csArr}             from "@Common/react/cs-arr";
import {keyed}             from "@Common/react/keyed";
import {Load}              from "@Common/react/load";
import {UseState}          from "@Common/react/use-state";
import {ConfirmDialog}     from "@Common/ui-components/heavy/common/design2/dialogs/confirm-dialog/confirm-dialog";
import {ModalService3}     from "@Common/ui-components/modal-service-3/modal-service-3";
import {OrderUsageHistory} from "@Xpresso/routes/account/wallet/vouchers-route/details-modal/order-usage-history/order-usage-history";

import {DetailsTable} from "./details-table/details-table";
import {EditPanel}    from "./edit-panel/edit-panel";
import {HistoryPanel} from "./history-panel/history-panel";

export const VoucherModal = ({vouchers, next: rootNext}) => cs(
    consumeContext("apis"),
    ["modal", (_, next) => ModalService3({
        xdQaName: "Voucher Modal",
        rootNext,
        width: 459,
        sidebar: {
            fullHeight: true,
        },
        contentService: next,
    })],
    ["history", ({modal: {params: {voucher}}, apis}, next) => Load({
        fetch: () => apis.next.vouchers.getVoucherHistory1(voucher.idVoucher),
        next,
    })],
    ["tabs", ({modal: {params: {voucher}}, history}, next) => csArr(
        tabsConfig.map((tab) => (
            (next) => tab.service({voucher, history, next})
        )),
        next,
    )],
    ["activeTab", (_, next) => UseState({
        initValue: "edit",
        next,
    })],
    ["confirmUpdate", ({}, next) => ConfirmDialog({
        next: (dialog) => next(() => dialog.show({
            message: "Are you sure you want to update this voucher?",
            actionName: null,
            buttons: {
                confirmLabel: "Confirm",
            },
        })),
    })],
    ["confirmClose", ({}, next) => ConfirmDialog({
        next: (dialog) => next(() => dialog.show({
            message: "Your changes have not been saved",
            actionName: "exit",
            buttons: {
                confirmLabel: "Yes",
            },
        })),
    })],
    ({modal: {params: {voucher}, close, next}, tabs, confirmClose, confirmUpdate, history, activeTab}) => {
        const tabIndex = tabsConfig.findIndex((t) => t.name === activeTab.value);
        const tabObj   = tabs[tabIndex];
        const editTab  = tabs[tabsConfig.findIndex((t) => t.name === "edit")];
        return next({
            onPassiveClose: async () => {
                const changedTabIndex = tabs.findIndex((t) => t.editable?.changed);
                if (changedTabIndex === -1) {
                    return true;
                }
                if (changedTabIndex === tabIndex) {
                    return tabObj.hasChanges() ? (
                        await confirmClose() && close()
                    ) : (
                        close()
                    )
                } else {
                    return editTab.hasChanges() ? (
                        activeTab.onChange(tabsConfig[changedTabIndex].name),
                        tabs[changedTabIndex].highlightChanges(),
                        await confirmClose() && close()
                    ) : (
                        close()
                    )
                }
            },
            content: (
                <div className="voucher-modal-14i">
                    <div className="main">

                        <div className="header" xd-qa-type="label" xd-qa-name={voucher.agentFullName + "'s Voucher"}>
                            {voucher.agentFullName}'s Voucher
                        </div>

                        <div className="tabs">
                            {tabsConfig.map((tab, i) => (
                                <div
                                    key={i}
                                    className={cx("item", {active: activeTab.value === tab.name})}
                                    onClick={() => activeTab.onChange(tab.name)}
                                    xd-qa-type="button"
                                    xd-qa-name={tab.label}
                                >
                                    {tab.label}
                                </div>
                            ))}

                        </div>


                        <div className="content">
                            {DetailsTable({history})}

                            <div className="tab-content">
                                {cs(
                                    keyed(activeTab.value),
                                    () => tabObj.renderContent({}),
                                )}
                            </div>
                        </div>
                    </div>

                    {tabObj.editable && (
                        <div className="footer">
                            <button {...{ 
                                className: "cancel",
                                onClick: async () => {
                                    tabObj.hasChanges() ? 
                                        await confirmClose() && close()
                                     : (
                                        close()
                                    )},
                            }}
                                xd-qa-type="button"
                                xd-qa-name="Cancel"
                            >
                                Cancel
                            </button>
                            <button {...{
                                className: cx("next", {disabled: tabObj.editable.invalid}),
                                disabled: !tabObj.editable.changed || tabObj.editable.invalid,
                                onClick: async () => {
                                    if(await confirmUpdate()) {
                                        close()
                                        await tabObj.editable.submit()
                                        vouchers.reset()
                                    }
                                }
                            }}
                                xd-qa-type="button"
                                xd-qa-name="Update"
                            >
                                Update
                            </button>
                        </div>
                    )}
                </div>
            ),
        });
    },
);

const tabsConfig = [
    {
        name : "edit",
        label: "Edit",
        service: ({voucher, history, next}) => EditPanel({voucher, next}),
    },
    {
        name : "usageHistory",
        label: "Usage History",
        service: ({voucher, history, next}) => cs(
            () => next({
                renderContent: () => OrderUsageHistory({voucher: history})
            })
        ),
    },
    {
        name : "balanceHistory",
        label: "Balance History",
        service: ({voucher, history, next}) => HistoryPanel({history, next}),
    },
];

